import React from 'react';
/* --- import Components ----*/
import { Sentence, SentenceSmall } from '../Typography';
/* --- import Icons ----*/
import { Calendar, CalendarMonth, Format, Video, Case, Discount } from 'src/components/Icons/Home';
import TeacherAssistantsx2 from 'src/components/Icons/TeacherAssistantsx2';
import TeacherAssistantsx4 from 'src/components/Icons/TeacherAssistantsx4';
import Lightbulb from 'src/components/Icons/Lightbulb';
import CodeScreen from 'src/components/Icons/CodeScreen';
import CoursePlatform from 'src/components/Icons/CoursePlatform';
import Alumni from '../Icons/Alumni';
import FinanceIconCircle from '../Icons/FinanceIconCircle';
/* --- import Styles  ----*/
import { useMediaQueries } from 'src/utils/MediaQueries';
/**
 * @type React.FunctionComponent<{ name: string, width: number | string, text: string, subtext: string }>
 */
const Features = ({ name, text, subtext, itemWidth = 220, light, qty }) => {
  const mqs = useMediaQueries();

  let itemsOnFirstsLine;
  if (qty > 4) {
    if (mqs.desktopUp) {
      if (qty % 2 === 0) {
        itemsOnFirstsLine = qty / 2;
      } else {
        itemsOnFirstsLine = (qty - (qty % 2)) / 2 + 1;
      }
    } else if (mqs.tabletLandscapeUp) {
      itemsOnFirstsLine = 4;
    } else if (mqs.tabletPortraitUp) {
      itemsOnFirstsLine = 3;
    }
  } else {
    itemsOnFirstsLine = mqs.tabletLandscapeUp ? qty : 2;
  }

  return (
    <li
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: `calc(100% / ${itemsOnFirstsLine})`,
        margin: '35px 0',
      }}
    >
      <div
        css={{
          marginBottom: light ? 10 : 16,
          width: itemWidth,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {name === 'calendar' ? (
          <Case />
        ) : name === 'format' ? (
          <Format />
        ) : name === 'diploma' ? (
          <Calendar />
        ) : name === 'video' ? (
          <Video />
        ) : name === 'platform' ? (
          <CoursePlatform />
        ) : name === 'teachersx2' ? (
          <TeacherAssistantsx2 />
        ) : name === 'teachersx4' ? (
          <TeacherAssistantsx4 />
        ) : name === 'support' ? (
          <Lightbulb />
        ) : name === 'formation' ? (
          <CodeScreen />
        ) : name === 'discount' ? (
          <Discount />
        ) : name === 'alumni' ? (
          <Alumni />
        ) : name === 'finance' ? (
          <FinanceIconCircle />
        ) : name === 'calendar2' ? (
          <CalendarMonth />
        ) : null}
      </div>

      <div
        css={{
          textAlign: 'center',
        }}
      >
        <Sentence
          css={{
            fontWeight: light ? null : 'bold',
            fontSize: light ? 18 : null,
            lineHeight: light ? '27px ' : null,
          }}
        >
          {text}
        </Sentence>
        {subtext ? <SentenceSmall>{subtext}</SentenceSmall> : null}
      </div>
    </li>
  );
};

export default Features;
